import { USER_CONSTANTS, globalConstants, TOAST_TYPES } from "../../constants";
import { ToastifyService, userService } from "../../services";
import { success } from "./utilities";
import { clearStorage, encryptObject, setItemToStorage } from "../../system";

//This action is called when user click on login
function login(userData, onSuccess) {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));

    userService
      .login(userData)
      .then((response) => {
        const encryptedToken = encryptObject(response.token);
        const encryptedData = encryptObject(response.user);
        setItemToStorage(process.env.REACT_APP_PAYLOAD, encryptedToken);
        setItemToStorage("encryptedData", encryptedData);
        dispatch(
          success(response, USER_CONSTANTS.LOGIN, globalConstants.SUCCESS)
        );
        // Call the callback after success
        if (onSuccess) onSuccess();
      })
      .catch((error) => {
        console.log("error", error);
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
}

//Function to clear user data and logout
function clearUserData() {
  return userService.logout();
}

//Function to logout
function logout() {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .logout()
      .then((response) => {
        clearStorage();
        window.location.href = "/";
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
}

export const getAllUser = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .getAll()
      .then((response) => {
        dispatch(success(response.data, USER_CONSTANTS.GET_USERS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getUserById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .getById(id)
      .then((response) => {
        dispatch(success(response.data, USER_CONSTANTS.GET_USER_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteUserById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllUser());
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createUser = (data, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .create(data)
      .then((response) => {
        dispatch(getAllUser());
        onHide();
        ToastifyService.showSuccess("Done Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateUser = (data, id, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .update(data, id)
      .then((response) => {
        dispatch(getAllUser());
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteUserPermanentById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .deleteUserPermanentById(id)
      .then((response) => {
        dispatch(getAllUser());
        ToastifyService.showSuccess("Deleted Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getPermissions = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .getPermissions()
      .then((response) => {
        dispatch(success(response.data, USER_CONSTANTS.GET_PERMISSIONS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getNotifications = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .getAllNotifications()
      .then((response) => {
        dispatch(success(response.data, USER_CONSTANTS.GET_NOTIFICATIONS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getNotificationById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .getNotificationById(id)
      .then((response) => {
        dispatch(
          success(response.data, USER_CONSTANTS.GET_NOTIFICATIONS_BY_ID)
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateNotification = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .updateNotification(data)
      .then((response) => {
        dispatch(getNotifications());
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};
export const changePassword = (data, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .changePassword(data)
      .then((response) => {
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};
//Exporting login actions for other files
export const userActions = {
  login,
  clearUserData,
  logout,
  getAllUser,
  getUserById,
  deleteUserById,
  createUser,
  updateUser,
  deleteUserPermanentById,
  getPermissions,
  getNotifications,
  getNotificationById,
  updateNotification,
  changePassword,
};
